import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { selectCurrentTab } from "@/features/yard360/NavigationTabs/selectors";
import { setCurrentTab } from "@/features/yard360/NavigationTabs/slice";
import { ROUTES, VIEW_TO_ROUTE } from "@/app/app-constants";
import { keys } from "@/i18n/keys";

interface NavigationTabsProps {
  tabs: string[];
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({ tabs }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentTab = useSelector(selectCurrentTab);

  React.useEffect(() => {
    // Set tab based on current path
    const path = location.pathname;
    if (path.includes(ROUTES.EQUIPMENT)) {
      dispatch(setCurrentTab(keys.EQUIPMENT));
    } else if (path.includes(ROUTES.APPOINTMENTS) || path.includes("/yard360")) {
      dispatch(setCurrentTab(keys.APPOINTMENTS));
    }
  }, [dispatch, navigate]);

  const handleTabChange = (tab: string) => {
    dispatch(setCurrentTab(tab));
    navigate(VIEW_TO_ROUTE[tab]);
  };

  return (
    <TabGroup value={currentTab} onChange={handleTabChange}>
      {tabs.map((tab) => (
        <Tab key={tab} value={tab}>
          {t(tab)}
        </Tab>
      ))}
    </TabGroup>
  );
};
